// AnimatedLoader.js
import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: transparent /* Optional: Background color */
`;

const Loader = styled.div`
  border: 8px solid #f3f3f3; /* Light grey background */
  border-radius: 50%;
  border-top: 8px solid #de283b; /* Blue color */
  width: 60px;
  height: 60px;
  animation: ${spin} 1s linear infinite;
`;

const LoginLoader = () => (
  <LoaderContainer>
    <Loader />
  </LoaderContainer>
);

export default LoginLoader;
